<script setup lang="ts">
import PublicEventPurchaseScreen from '~/modules/public/purchase/presentation/PublicEventPurchaseScreen.vue'

definePageMeta({ middleware: ['branding-context'], purchaseFlow: true })
const route = useRoute()
const slug = computed(() => String(route.params.slug))
</script>

<template>
  <PublicEventPurchaseScreen :key="slug" :slug="slug" />
</template>
